import { Layout } from "@/components/layout";
import ConnectionsContent from "@/components/connections-content";

export default function MetaConnectionsPage() {
  return (
    <Layout>
      <div className="p-6" data-testid="meta-connections-page">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Connections</h1>
        <ConnectionsContent />
      </div>
    </Layout>
  );
}
